module.exports = __webpack_public_path__ + "img/hafffling.176a8bfe.svg";